import React from "react";
import { Layout1 } from "./components/Layout1";
import { Layout24 } from "./components/Layout24";
import { Layout240 } from "./components/Layout240";
import { Contact14 } from "../components/shared/Contact14";
import { Footer } from "../components/shared/Footer";

export default function Page() {
  return (
    <div>
      <div className="w-full bg-gradient-to-r from-blue-700 to-purple-700 text-white text-center py-4 font-semibold text-lg shadow-md">
        Omnigeist.ai is now entering early access. You can request a code when your turn comes up.
      </div>
      <Layout1 />
      <Layout24 />
      <Layout240 />      
      <Contact14 />
      <Footer />
    </div>
  );
}
